import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40100164"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 참여가능 클럽딜 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" TODAY ")
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 리드엔젤 ")
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 가격 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 로그인 후 확인 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 진행률 ")
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 리드엔젤 ")
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 가격 ")
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_intersect_box = _resolveComponent("ag-intersect-box")!
  const _component_ag_img = _resolveComponent("ag-img")!

  return (_openBlock(), _createBlock(_component_ag_box_s, { css: {backgroundColor: '#F7F8FB',padding: '32px 20px'} }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box_s, { css: {marginBottom: '16px;', fontSize:'20px'} }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text_s, { css: {fontWeight:700} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text_s, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.clubdealCount), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_box_s, { css: {
        fontWeight: 900,
        fontSize: '16px',
        marginBottom: '24px',
      } }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collectingLeadDeals, (deal) => {
        return (_openBlock(), _createBlock(_component_ag_intersect_box, {
          key: deal.partnershipId,
          css: {minHeight: 180, width: '100%'}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box_s, {
              css: {marginBottom:'30px'},
              onClick: () =>{
          _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'클럽딜 TODAY', 'clickContent':`${deal.partnershipName}`});
          _ctx.useClubDealProgressModal(deal.partnershipId)
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box_s, { css: {
            marginTop: '15px',
            marginBottom: '16px',
            display: 'flex',
          } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {
              marginRight: '10px',
            } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_box_s, { css: {
                position: 'absolute',
                height: '80px',
                borderLeft: '1px solid #222',
                left: '12px',
                top: '3px',
              } }),
                        _createVNode(_component_ag_box_s, { css: {
                width: 24,
                height: 24,
                position: 'relative'
              } }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              alt: "owner-profile",
                              src: deal.ownerProfile ? deal.ownerProfile : '/assets/icon/lead_default_profile.png',
                              style: {borderRadius:'50%'}
                            }, null, 8, _hoisted_3)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ag_box_s, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_text_s, { css: {
                marginRight: '8px'
              } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_text_s, { css: {
                  fontWeight: '700',
                } }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(deal.owner), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _hoisted_4
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ag_text_s, { css: {
                fontSize: '12px',
                color:'#8F929B',
              } }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 리드엔젤 " + _toDisplayString(deal.leadCount) + "회차 ", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ag_box_s, {
                  style: _normalizeStyle({
            color : deal.fontColor,
            'box-shadow' : `0px 25px 50px -30px ${deal.bgColor}`,
            borderRadius: '10px',
          })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box_s, { css: {
              boxShadow: 'inset 0 0 100px rgba(0, 0, 0, 0.6)',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              backgroundSize: 'cover',
              overflow: 'hidden',
              position: 'relative',
              width: '100%',
              height: '80px',
              padding: '18px 10px 10px 20px',
              borderRadius: '10px 10px 0px 0px',
            } }, {
                      default: _withCtx(() => [
                        (deal.cardBgUrl)
                          ? (_openBlock(), _createBlock(_component_ag_box_s, {
                              key: 0,
                              "container-as": "img",
                              css: {
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
                position: 'absolute',
              },
                              src: deal.cardBgUrl
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ag_box_s, { css: {width: '100%', height: '100%', left: 0, top: 0, position: 'absolute', bg: 'black', opacity: 0.2} }, null, 8, ["css"]),
                        _createVNode(_component_ag_box_s, { css: {
                display: 'flex',
                alignContent: 'flex-start',
              } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_box_s, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ag_box_s, { css: {
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                  } }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      alt: "company-logo",
                                      src: deal.companyLogo,
                                      onerror: "this.src='https://static.angelleague.io/images/bk_v.png'",
                                      style: {
                      borderRadius: '50%',
                    }
                                    }, null, 8, _hoisted_5),
                                    _createVNode(_component_ag_box_s, { css: {
                      boxShadow: 'inset 0 0 0 1px rgba(68 68 68, 0.08)',
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      borderRadius: '50%',
                      top: '0',
                      left: '0',
                    } }, null, 8, ["css"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ag_box_s, { css: {marginLeft: '10px'} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ag_box_s, { css: {
                    fontSize: '18px',
                    fontWeight: '550',
                  } }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(deal.partnershipName), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ag_box_s, {
                                  style: {"font":"var(--main_14R)"},
                                  css: {
                    marginBottom: '14px',
                    display: 'flex',
                    alignItems: 'center',
                  }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ag_box_s, {
                                      style: {"text-overflow":"ellipsis"},
                                      css: {
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                    }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ag_text_s, { style: {"font":"var(--main_14R)"} }, {
                                          default: _withCtx(() => [
                                            (Number(deal.currentValuation))
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" 추정기업가치 " + _toDisplayString(_ctx.numberToKorean(deal.currentValuation)) + "원 ", 1)
                                                ], 64))
                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createTextVNode(" 진행중 " + _toDisplayString(_ctx.$filters.getMonthDay(deal.dueDateFrom)) + " ~ " + _toDisplayString(_ctx.$filters.getMonthDay(deal.dueDate)), 1)
                                                ], 64))
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ag_box_s, { css: {marginLeft: '12px'} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ag_box_s, {
                                          "container-as": "img",
                                          css: {
                        width: '12px !important',
                        height: '12px !important',
                        marginLeft: '1.5px',
                        marginRight: '3px',
                        display: 'inline-block',
                      },
                                          src: "/assets/icon/small_leaf_g.png"
                                        }, null, 8, ["css"]),
                                        _createVNode(_component_ag_text_s, { css: {
                        color:'#3EBA1F'
                      } }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString((deal.avgPoint*1).toFixed(1)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["css"]),
                    _createVNode(_component_ag_box_s, {
                      css: {
              padding: '16px 20px 19px 20px',
              fontSize: '14px',
              fontWeight: '200',
              lineHeight: '20px',
              borderRadius: '0px 0px 10px 10px',
            },
                      style: _normalizeStyle({'background-color': deal.bgColor })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_box_s, { css: {
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '5px',
              } }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ag_box_s, { css: {display: 'flex'} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ag_text_s, { css: {
                    typography: 'main14r',
                    paddingRight: '8px',
                    color: 'rgba(255, 255, 255, 0.7)'
                  } }, {
                                  default: _withCtx(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                }, 8, ["css"]),
                                _createVNode(_component_ag_box_s, { css: {
                    typography: 'main14r',
                    paddingRight: '8px',
                    color: 'rgba(255, 255, 255, 0.7)'
                  } }, {
                                  default: _withCtx(() => [
                                    (_ctx.hasSession())
                                      ? (_openBlock(), _createBlock(_component_ag_text_s, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ag_text_s, { css: {
                        fontWeight: '700',
                        color:'#fff',
                      } }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$filters.currency(deal.purchasePrice)), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _hoisted_7
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : (_openBlock(), _createBlock(_component_ag_text_s, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _hoisted_8
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _: 2
                                }, 1032, ["css"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ag_box_s, { class: "cur_info_right" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ag_text_s, { css: {
                    typography: 'main14r',
                    paddingRight: '8px',
                    color: 'rgba(255, 255, 255, 0.7)'
                  } }, {
                                  default: _withCtx(() => [
                                    _hoisted_9
                                  ]),
                                  _: 1
                                }, 8, ["css"]),
                                _createVNode(_component_ag_box_s, { css: {
                    paddingRight: '8px',
                    color: 'rgba(255, 255, 255, 0.7)'
                  } }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ag_text_s, { css: {
                      fontWeight: '700',
                      color:'#fff',
                    } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString((deal.collectedRate * 100).toFixed(0)) + " % ", 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["css"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["style"])
                  ]),
                  _: 2
                }, 1032, ["style"])
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.upcomingLeadDeals).sort(), (date) => {
        return (_openBlock(), _createBlock(_component_ag_intersect_box, {
          key: date,
          css: {minHeight: 180}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_box_s, { css: {
          marginBottom: '24px',
          fontSize: '16px',
          fontWeight: 700,
        } }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.clubDate(date)), 1)
              ]),
              _: 2
            }, 1024),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingLeadDeals[date], (deal) => {
              return (_openBlock(), _createBlock(_component_ag_box_s, {
                key: deal.partnershipId,
                css: {
          marginBottom: '30px',
        }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_box_s, { css: {
            marginTop: 15,
            marginBottom: 16,
            display: 'flex',
          } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_box_s, { css: {
              marginRight: 10,
            } }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_box_s, { css: {
                position: 'absolute',
                height: '80px',
                borderLeft: '1px solid #222',
                left: '12px',
                top: '3px',
              } }),
                          _createVNode(_component_ag_box_s, { css: {
                width: 24,
                height: 24,
              } }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                src: deal.ownerProfile ? deal.ownerProfile : '/assets/icon/lead_default_profile.png',
                                style: {borderRadius:'50%'}
                              }, null, 8, _hoisted_10)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ag_box_s, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_text_s, { css: {
                marginRight: '8px'
              } }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ag_text_s, { css: {
                  fontWeight: '700',
                } }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(deal.owner), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _hoisted_11
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ag_text_s, { css: {
                fontSize: '12px',
                color:'#8F929B',
              } }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 리드엔젤 " + _toDisplayString(deal.leadCount) + "회차 ", 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ag_box_s, {
                    style: _normalizeStyle({
            color : deal.fontColor,
            'box-shadow' : `0px 2px 15px rgba(0, 0, 0, 0.1)`
          }),
                    css: {
            borderRadius: '10px 10px 10px 10px',
            color: '#fff',
            width: '100%',
            backgroundColor: '#fff',
            marginBottom: '24px',
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ag_box_s, {
                        css: {
              boxShadow: 'inset 0 0 100px rgba(0, 0, 0, 0.6)',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              backgroundSize: 'cover',
              overflow: 'hidden',
              position: 'relative',
              width: '100%',
              height: '80px',
              padding: '18px 10px 10px 20px',
              borderRadius: '10px 10px 0px 0px',
            },
                        onClick: () =>{
              _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'클럽딜 업커밍', 'clickContent':`${deal.partnershipName}`})
              _ctx.useClubDealProgressModal(deal.partnershipId)
            }
                      }, {
                        default: _withCtx(() => [
                          (deal.cardBgUrl)
                            ? (_openBlock(), _createBlock(_component_ag_box_s, {
                                key: 0,
                                "container-as": "img",
                                css: {
                objectFit: 'cover',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
                position: 'absolute',
              },
                                src: deal.cardBgUrl
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ag_box_s, { css: {width: '100%', height: '100%', left: 0, top: 0, position: 'absolute', bg: 'black', opacity: 0.2} }, null, 8, ["css"]),
                          _createVNode(_component_ag_box_s, { css: {
                display: 'flex',
                alignContent: 'flex-start',
              } }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ag_box_s, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ag_box_s, { css: {
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                  } }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        alt: "company-logo",
                                        onerror: "this.src='https://static.angelleague.io/images/bk_v.png'",
                                        src: deal.companyLogo,
                                        style: {
                      borderRadius: '50%',
                    }
                                      }, null, 8, _hoisted_12),
                                      _createVNode(_component_ag_box_s, { css: {
                      boxShadow: 'inset 0 0 0 1px rgba(68 68 68, 0.08)',
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      borderRadius: '50%',
                      top: '0',
                      left: '0',
                    } }, null, 8, ["css"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ag_box_s, { css: {marginLeft: '10px'} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ag_box_s, { css: {
                    fontSize: '18px',
                    fontWeight: '550',
                  } }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(deal.partnershipName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ag_box_s, {
                                    style: {"font":"var(--main_14R)"},
                                    css: {
                    marginBottom: '14px',
                    display: 'flex',
                    alignItems: 'center',
                  }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ag_box_s, {
                                        style: {"text-overflow":"ellipsis"},
                                        css: {
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                    }
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ag_text_s, { style: {"font":"var(--main_14R)"} }, {
                                            default: _withCtx(() => [
                                              (Number(deal.currentValuation))
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(" 추정기업가치 " + _toDisplayString(_ctx.numberToKorean(deal.currentValuation)) + "원 ", 1)
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode(" 진행예정 " + _toDisplayString(_ctx.$filters.getMonthDay(deal.dueDateFrom)) + " ~ " + _toDisplayString(_ctx.$filters.getMonthDay(deal.dueDate)), 1)
                                                  ], 64))
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ag_box_s, { css: {marginLeft: '12px'} }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ag_box_s, {
                                            "container-as": "img",
                                            css: {
                        width: '12px !important',
                        height: '12px !important',
                        marginLeft: '1.5px',
                        marginRight: '3px',
                        display: 'inline-block',
                      },
                                            src: "/assets/icon/small_leaf_g.png"
                                          }, null, 8, ["css"]),
                                          _createVNode(_component_ag_text_s, { css: {
                        color:'#3EBA1F'
                      } }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString((deal.avgPoint*1).toFixed(1)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["css", "onClick"]),
                      _createVNode(_component_ag_box_s, { css: {padding: '16px 20px 19px 20px;'} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_box_s, { css: {
                display: 'flex',
                justifyContent: 'space-between',
                color: '#222',
              } }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ag_box_s, { css: {display: 'inline-flex'} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ag_box_s, { css: {
                    paddingRight: '8px',
                    color: 'rgba(34, 34, 34, 0.7)'
                  } }, {
                                    default: _withCtx(() => [
                                      _hoisted_13
                                    ]),
                                    _: 1
                                  }, 8, ["css"]),
                                  _createVNode(_component_ag_box_s, { css: {
                    fontSize: '14px',
                    color: '#8F929B',
                  } }, {
                                    default: _withCtx(() => [
                                      (_ctx.hasSession())
                                        ? (_openBlock(), _createBlock(_component_ag_text_s, { key: 0 }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$filters.currency(deal.purchasePrice)) + " 원 ", 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_14, "로그인 후 확인"))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ag_box_s, {
                                css: {
                  display: 'flex',
                  alignItems: 'center',
                },
                                onClick: ($event: any) => (_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'클럽딜 업커밍', 'clickContent':`관심버튼`})(_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.partnershipLike(deal.partnershipStatus, 'upcomingLeadDeals',deal.partnershipId)))
                              }, {
                                default: _withCtx(() => [
                                  (deal.partnershipLikeId)
                                    ? (_openBlock(), _createBlock(_component_ag_img, {
                                        key: 0,
                                        style: {
                    width: '19px !important',
                    height: '19px !important',
                    marginRight: '6px',
                  },
                                        src: "/assets/icon/heart_n_g.png",
                                        srcset: "/assets/icon/heart_n_g@2x.png 2x,/assets/icon/heart_n_g@3x.png 3x"
                                      }))
                                    : (_openBlock(), _createBlock(_component_ag_img, {
                                        key: 1,
                                        style: {
                    width: '19px !important',
                    height: '19px !important',
                    marginRight: '6px',
                  },
                                        src: "/assets/icon/heart_s_g.png",
                                        srcset: "/assets/icon/heart_s_g@2x.png 2x,/assets/icon/heart_s_g@3x.png 3x"
                                      })),
                                  _createVNode(_component_ag_text_s, {
                                    class: _normalizeClass({'deep-blue':deal.partnershipLikeId>0, grey:!deal.partnershipLikeId}),
                                    style: _normalizeStyle({
                    font: 'var(--main_12R)',
                    color:'#999'
                  })
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(deal.likeCount), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class", "style"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["style"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}